module.exports = __webpack_public_path__ + "media/IntroduceVideo.cc7a7cbf.mp4";